import Vue from 'vue'
import router from './router'
import store from './store'
// import 'lib-flexible/flexible.js'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import 'lib-flexible'
// import '../public/lib/flexible.js'
//vue动态导航栏
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//copy
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
// 1
// import dxui1 from './packages/index1'
// Vue.use(dxui1)
// import dxui2 from './packages/alert/index'
// Vue.use(dxui2)
//2
// 引入
import { messageControl } from './components/message'
// 初始化绑定
const notifyCompoent = new messageControl()
Vue.prototype.$alert = notifyCompoent.message.bind(notifyCompoent)


//遍历所有图片
let files = require.context('./assets/charadb', true, /\.png$|\.jpg$|\.webp$/);
store.state.body = {};
files.keys().forEach(key => {
  store.state.body[key.replace(/(.\/)/, '')] = files(key);
});
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')